import { render, staticRenderFns } from "./SubMain.vue?vue&type=template&id=30d49fe6"
import script from "./SubMain.vue?vue&type=script&lang=js"
export * from "./SubMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports